export default {
  // Общие элементы
  common: {
    loading: "Загрузка...",
    save: "Сохранить",
    cancel: "Отмена",
    edit: "Редактировать",
    delete: "Удалить",
    search: "Поиск",
    close: "Закрыть",
    back: "Назад",
    next: "Следующий",
    previous: "Предыдущий",
    submit: "Отправить",
    confirm: "Подтвердить",
    yes: "Да",
    no: "Нет",
    all: "Все",
    rating: "Рейтинг",
    services: "Услуги",
    hajj: "Хадж",
    umra: "Умра",
  },

  // Навигация
  navigation: {
    home: "Главная",
    about: "О нас",
    news: "Новости",
    article: "Статьи",
    qa: "Вопрос-ответ",
    tours: "Туры",
    other: "Другое",
    contacts: "Контакты",
    profile: "Профиль",
    login: "Вход",
    register: "Регистрация",
    logout: "Выход",
  },

  // Заголовки
  headers: {
    logoTitle: "Паломники Казахстана",
    logoSubtitle: "Hajj.kz",
  },

  // Меню
  menu: {
    home: "Главная",
    about: "О нас",
    news: "Новости",
    contacts: "Контакты",
    profile: "Профиль",
    liveStreaming: "Прямой эфир",
    sendPrayer: "Отправить дуа",
  },

  // Языки
  languages: {
    kk: "Қаз",
    ru: "Рус",
    en: "Eng",
  },

  // Регионы
  regions: {
    astana: "Астана",
    almaty: "Алматы",
    shymkent: "Шымкент",
    aktobe: "Актобе",
    karaganda: "Караганда",
    taraz: "Тараз",
    pavlodar: "Павлодар",
    oskemen: "Усть-Каменогорск",
    semey: "Семей",
    atyrau: "Атырау",
    uralsk: "Уральск",
    kyzylorda: "Кызылорда",
    aktau: "Актау",
    petropavl: "Петропавловск",
    kokshetau: "Кокшетау",
    taldykorgan: "Талдыкорган",
  },

  // Время намаза
  prayerTimes: {
    fajr: "Фаджр",
    sunrise: "Восход",
    dhuhr: "Зухр",
    asr: "Аср",
    maghrib: "Магриб",
    isha: "Иша",
  },

  // Формы
  forms: {
    email: "Электронная почта",
    password: "Пароль",
    confirmPassword: "Подтвердите пароль",
    firstName: "Имя",
    lastName: "Фамилия",
    phone: "Телефон",
    city: "Город",
    region: "Регион",
    address: "Адрес",
    birthDate: "Дата рождения",
    passportNumber: "Номер паспорта",
    required: "Обязательное поле",
    invalidEmail: "Неверный email",
    passwordMismatch: "Пароли не совпадают",
    fullName: "Полное имя",
    phonePlaceholder: "+7 (___) ___-__-__",
    phoneError: "Введите правильный номер телефона",
  },

  // Сообщения
  messages: {
    success: "Успешно выполнено",
    error: "Произошла ошибка",
    warning: "Предупреждение",
    info: "Информация",
    saved: "Сохранено",
    deleted: "Удалено",
    updated: "Обновлено",
    languageChanged: "Cтраница будет перезагружена для применения нового языка",
  },

  // Аутентификация
  auth: {
    welcome: "Добро пожаловать!",
    connectToSystem: "Подключиться к системе",
    loginTitle: "Вход в систему",
    registerTitle: "Регистрация",
    forgotPassword: "Забыли пароль?",
    rememberMe: "Запомнить меня",
    loginButton: "Войти",
    registerButton: "Зарегистрироваться",
    resetPassword: "Сбросить пароль",
    alreadyHaveAccount: "Уже есть аккаунт?",
    dontHaveAccount: "Нет аккаунта?",
    loginSuccess: "Успешный вход",
    registerSuccess: "Успешная регистрация",
    logoutSuccess: "Успешный выход",
    registerSuccessTitle: "Успешно зарегистрировались!",
    registerSuccessDescription: "Для входа в систему введите логин и пароль.",
    loginButtonText: "Войти",
  },

  // Профиль
  profile: {
    personalInfo: "Личная информация",
    orders: "Заявки",
    settings: "Настройки",
    changePassword: "Изменить пароль",
    editProfile: "Редактировать профиль",
    saveChanges: "Сохранить изменения",
    personalCabinet: "Личный кабинет",
    editPersonalInfo: "Редактировать личную информацию",
    fullName: "Полное имя",
    fullNamePlaceholder: "Введите ваше полное имя",
    emailPlaceholder: "Введите E-mail",
    removeEmail: "Удалить E-mail",
    save: "Сохранить",
    saving: "Сохранение...",
    noOrders: "У вас нет заявок",
    orderDate: "Дата заявки",
    pilgrimName: "Имя паломника",
    status: "Статус",
    statusPublished: "Опубликовано",
    statusModeration: "На модерации",
    statusAccepted: "Ваша заявка принята! Вы зарегистрированы в базе хаджи.",
    statusPending:
      "На рассмотрении. После принятия заявки ваш профиль будет опубликован в базе.",
    logout: "Выйти из системы",
  },

  // Хадж
  hajj: {
    title: "Хадж",
    mission: "Миссия",
    register: "Регистрация",
    search: "Поиск",
    holyPlaces: "Священные места",
    tourOperators: "Туроператоры",
    news: "Новости",
    videos: "Видео",
    photos: "Фотографии",
    books: "Книги",
    hajjis: "Паломники",
    hajjisList: "Список паломников",
    hajjUmra: "Хадж и Умра",
    tourCompanies: "Туристические компании",
    hajjMission: "Казахстанская хадж миссия",
    hajjRegistration: "База регистрации паломников Казахстана",
    registeredHajjis: "Зарегистрировано паломников",
    hajjYear: "Год совершения хаджа",
    selectRegion: "Выберите регион:",
    searchHajjis: "Поиск паломников",
    searchSubtitle: "Введите имя и выберите регион для поиска",
    fullName: "Полное имя",
    selectYear: "Год совершения хаджа",
    hajjDate: "Год поездки в хадж",
    hajjUntil: "До хаджа осталось",
    hajjDateText: "Хадж {day} {month} {year}г",
    hajjYearText: "Год поездки в хадж",
    age: "Возраст",
    region: "Регион",
    biography: "Биография",
    impressions: "Впечатления от хаджа",
    advice: "Советы паломников",
    hajjAccepted: "Пусть ваш хадж будет принят!",
    amin: "Амин!",
    dua: "Сделайте мне дуа",
    duaDescription:
      "Вы можете попросить дуа для себя или своих близких. Пусть Аллах примет каждое дуа!",
    sendDua: "Отправить дуа",
    searchByName: "Поиск по имени",
    new: "Новые",
    old: "Старые",
    sampleDuaText:
      "Аллахумма инни ас'алука мин хайри ма са'аляка минху набийюка Мухаммадун саллаллаху алейхи ва саллям, ва а'узу бика мин шарри маста'аза минху набийюка Мухаммадун саллаллаху алейхи ва саллям.",
    authorName: "Ахметов Азамат",
    authorDetails: "Год совершения хаджа: 2024",
    hajjiMadeDua: "хаджи сделал дуа",
    noDua: "Нет дуа",
    duaForm: {
      title: "Отправить дуа",
      subtitle:
        "Вы можете попросить дуа для себя или своих близких. Пусть Аллах примет каждое дуа!",
      region: "Регион",
      duaType: "Тип дуа",
      duaText: "Текст дуа (обязательно)",
      duaTextPlaceholder:
        "Напишите вашу просьбу о дуа... (например: «Прошу дуа за здоровье моей сестры Салтанат...»)",
      submitButton: "Отправить дуа",
      submitting: "Отправляется...",
      fillAllFields: "Заполните все поля",
      successTitle: "Ваша просьба о дуа успешно принята!",
      successDescription:
        "После прохождения модерации будет опубликована на сайте. Пусть Аллах примет ваше намерение!",
      closeButton: "Закрыть",
      sendAnotherButton: "Отправить еще одно дуа",
    },
    duaActions: {
      noDuaYet:
        "Пока никто из хаджи не совершил дуа за это намерение. Станьте первым, кто искренне совершит дуа и внесет вклад в благое дело!",
      makeDua: "Совершить дуа",
      duaLiked: "Ваше дуа успешно отправлено!",
      youMadeDua: "Вы уже совершили дуа",
    },
    months: {
      january: "январь",
      february: "февраль",
      march: "март",
      april: "апрель",
      may: "май",
      june: "июнь",
      july: "июль",
      august: "август",
      september: "сентябрь",
      october: "октябрь",
      november: "ноябрь",
      december: "декабрь",
    },
  },

  // Медиа
  media: {
    title: "Медиа",
    articles: "Статьи",
    qa: "Вопрос-ответ",
    videoSection: "Видеоролики",
    photoGallery: "Фотогалерея",
    library: "Библиотека",
    goToQa: "Перейти к вопросам-ответам",
    goToNews: "Перейти к новостям",
    moreDetails: "Подробнее",
    videoContent: "Видеоконтент",
    videos: "Видеоролики",
    photos: "Фотогалерея",
    books: "Библиотека",
    author: "Автор",
    publisher: "Издательство",
    pages: "Количество страниц",

    year: "Год издания",
    shortDescription: "Краткое описание",
    read: "Читать",
    noAdditionalInfo: "Дополнительная информация отсутствует",
    seeAlso: "Смотрите также",
    share: "Поделиться",
    linkCopied: "Ссылка скопирована",
    copyFailed: "Не удалось скопировать ссылку",
    category: "Категория",
    source: "Источник",
    views: "Просмотры",
    date: "Дата",
  },

  // Онлайн трансляция
  liveStreaming: {
    title: "Онлайн трансляция",
    liveStream: "прямой эфир",
    mekke: "Мекка",
    medina: "Медина",
  },

  // Футер
  footer: {
    contact: "Контакты",
    address: "Адрес",
    phone: "Телефон",
    email: "Электронная почта",
    social: "Социальные сети",
    copyright: "Авторские права",
    allRightsReserved: "Все права защищены",
    addressValue: "г. Астана, ул. Карасаз, 3",
    phoneValue: "+ 7 (7172) 999 387",
    registered: "Зарегистрировано",
    hajji: "паломников",
    applyButton: "Подать заявку",
    onlineStreaming: "Онлайн трансляция",
  },

  // Статистика
  stats: {
    registered: "Зарегистрировано",
    hajji: "паломники",
    count: "401",
  },

  // Святые места
  holyPlaces: {
    title: "Священные места",
    mecca: "Мекка",
    medina: "Медина",
    meccaDescription: "Святейший город ислама, место расположения Каабы.",
    medinaDescription:
      "Место, куда переселился и был похоронен пророк Мухаммад (с.а.в.).",
    all: "Все",
    kaaba: "Кааба (аль-Масджид аль-Харам)",
    kaabaDescription:
      "Кааба — святейшее место в исламе. По верованию мусульман, её построили Ибрахим (а.с.) и его сын Исмаил (а.с.) по велению Аллаха. Кааба — кибла мусульман, то есть направление, куда они поворачиваются лицом во время молитвы. Она является символом единства ислама и преданности Аллаху.",
    location: "Местоположение: Мекка",
    map: "Карта",
  },

  // Туроператоры
  tourOperators: {
    title: "Туроператоры",
    rating: "Рейтинг",
    services: "Услуги",
    hajj: "Хадж",
    umra: "Умра",
    serviceType: "Тип услуг",
    features: "Особенности",
    location: "Местоположение",
    photoGallery: "Фотогалерея",
    links: "Ссылки",
    contactNumber: "Контактный номер",
    logoAlt: "Логотип туроператора",
    evaluation: "Оценка и оставление отзыва",
    evaluationText:
      "Для оценки услуг туроператора войдите на сайт или зарегистрируйтесь",
    reviews: "Отзывы",
    reply: "Ответ",
    companyName: "Атлас Туризм",
    replyText: "Азамат, спасибо за ваш отзыв! Мы рады снова вас видеть.",
    reviewText1:
      "Был в хадже. Хорошо организованный тур. Гид и руководители группы очень помогли. Спасибо всем!",
    reviewText2:
      "Очень хороший тур. В следующем году снова поеду с этой компанией.",
    userName1: "Гульнара Алиева",
    userName2: "Азамат Сериков",
    viewTours: "Посмотреть туры",
  },

  // Статьи
  articles: {
    back: "Назад",
    share: "Поделиться",
    seeAlso: "Смотрите также",
    category: "Категория",
    source: "Источник",
  },

  // FAQ
  faq: {
    title: "Вопрос-ответ",
    goToQa: "Перейти к вопросам-ответам",
    loading: "Загрузка...",
    error: "Произошла ошибка при загрузке данных. Попробуйте позже.",
  },

  // Миссия
  mission: {
    organizeHajj: "Организация и контроль хаджа",
    getQuota: "Получение квоты на хадж для Казахстана",
    approveOperators: "Утверждение туроператоров, организующих хадж",
    monitorRegistration: "Контроль системы регистрации хаджи",
    religiousAdvice: "Консультации хаджи по религиозным вопросам",
    qualityControl: "Контроль качества услуг туроператоров",
    security: "Обеспечение безопасности хаджи",
    evaluation: "Оценка качества хаджа и отчетность",
  },

  // Партнеры
  partners: {
    title: "Наши партнеры",
  },

  // Новости
  news: {
    title: "Новости",
    goToNews: "Перейти к новостям",
    moreDetails: "Подробнее",
    latest: "Последние новости",
  },

  // Выбор региона
  regionSelector: {
    title: "Выберите регион",
    search: "Поиск",
    back: "Назад",
  },

  // Пагинация
  pagination: {
    back: "Назад",
    next: "Следующий",
  },

  // Мобильные приложения
  mobileApps: {
    title: "Qaji Guide",
    subtitle:
      "Бесплатный цифровой инструмент для паломников, совершающих хадж и умру.",
  },

  // Время (для CountDown)
  time: {
    days: "дней",
    hours: "часов",
    minutes: "минут",
    seconds: "секунд",
  },

  // Дополнительные элементы
  additional: {
    addressLabel: "Адрес:",
    phoneLabel: "Телефон:",
    copyrightText: "2025 © Паломники Казахстана. Все права защищены",
  },

  // Форма паломника
  pilgrimForm: {
    title: "Подать заявку",
    description:
      "Вы или ваш родственник были в хадже? Зарегистрируйтесь в базе паломников Казахстана",
    step1Title: "Личная информация",
    step2Title: "Биография",
    step3Title: "Впечатления от хаджа",
    step3AdviceTitle: "Советы паломникам",
    fields: {
      lastName: "Фамилия",
      firstName: "Имя",
      fatherName: "Отчество",
      age: "Возраст",
      ageHint: "В каком возрасте вы совершили хадж?",
      region: "Регион, населенный пункт",
      regionHint: "Пример: Алматинская область, Талгарский район",
      hajjYear: "Год поездки в хадж",
      iin: "ИИН",
      photo: "Загрузка фото",
      biography: "Биография",
      biographyPlaceholder: "Напишите вашу биографию",
      biographyHint:
        "Например: место рождения, профессия, семья, религиозная деятельность",
      impressions: "Впечатления от хаджа",
      impressionsPlaceholder: "Напишите ваши впечатления от хаджа",
      impressionsHint:
        "Например: Момент, когда я впервые увидел Каабу в хадже, стал самым незабываемым в моей жизни",
      advice: "Советы паломникам",
      advicePlaceholder: "Напишите ваш совет паломникам",
      adviceHint: "Пример: советы, подготовка, дуа, терпение, духовный совет",
    },
    photoUpload: {
      title: "Загрузка фото",
      description: "Загрузите ваше официальное фото или фото в ихраме",
      button: "Загрузить",
      hint: "* Например: формат паспорта или фото во время хаджа",
    },
    validation: {
      lastName: "Введите вашу фамилию",
      firstName: "Введите ваше имя",
      age: "Введите ваш возраст",
      region: "Выберите регион, населенный пункт",
      hajjYear: "Введите год поездки в хадж",
      iin: "Введите ваш ИИН",
      photo: "Загрузите ваше фото",
    },
    buttons: {
      next: "Следующий",
      submit: "Отправить заявку",
    },
    messages: {
      success: "Ваша заявка отправлена",
      error: "Ваша заявка не отправлена",
    },
  },

  // Туры
  tours: {
    title: "Туры",
    filter: "Фильтр",
    reset: "Сбросить",
    priceFrom: "От",
    priceTo: "До",
    duration: "Срок",
    packageType: "Выбрать тип пакета",
    tourType: "Тип тура",
    allCities: "Все города",
    orderButton: "Оставить заявку",
    moreDetails: "Подробнее",
    remainingSeats: "Оставшиеся места",
    noToursFound: "По вашим фильтрам туры не найдены",
    clearFilters: "Очистить фильтры",
    loadingError: "Ошибка при загрузке туров",
    retry: "Повторить",
    company: "Компания",
    tourOperators: "Туроператоры",
    departureDate: "Дата вылета",
    returnDate: "Дата прилёта",
    directFlight: "прямой рейс",
    oneTransfer: "1 пересадка",
    transfers: "{count} пересадки",
    medinaIn: "В Медине",
    meccaIn: "В Мекке",
    medinaCity: "Медина",
    meccaCity: "Мекка",
    nights: "ночей",
    dayPackage: "дневной пакет",
    econom: "Эконом",
    standart: "Стандарт",
    comfort: "Комфорт",
    lux: "Люкс",
    all: "Все",
    umra: "Умра",
    hajj: "Хадж",
    days7: "7 дней",
    days10: "10 дней",
    days14: "14 дней",
    days21: "21 день",
    days30: "30 дней",
    back: "Назад",
    aboutPackage: "О пакете",
    flightTime: "Время перелёта",
    hajjDays: "Дни хаджа",
    packageIncludes: "Что входит в пакет",
    writeManager: "Написать менеджеру",
    route: "Маршрут",
    outbound: "Туда",
    returnTrip: "Обратно",
    hotels: "Отели",
    hotelsDescription:
      "В рамках данной программы Вы будете размещены в нижеуказанных отелях в Мекке и Медине. Уровень и условия отелей соответствуют классу пакета (Эконом / Комфорт / Люкс).",
    medinaHotel: "Отель в Медине",
    meccaHotel: "Отель в Мекке",
    distanceToNabawi: "Расстояние до Масджид ан-Набави:",
    distanceToHaram: "Расстояние до аль-Харам:",
    onFoot: "пешком",
    accommodation: "Размещение",
    meals: "Питание",
    nightsCount: "Количество ночей",
    viewGallery: "Смотреть галерею",
    detailLoadError: "Ошибка при загрузке деталей тура",
    booking: {
      fullName: "Ваше имя, фамилия",
      phone: "Номер телефона",
      email: "E-mail",
      consent:
        "Я согласен на обработку персональных данных. Данные используются для обработки заявки, связи и оформления тура. Политика конфиденциальности —",
      consentLink: "ссылка.",
      submitting: "Отправляется...",
      submit: "Оставить заявку",
      successTitle: "Ваша заявка принята!",
      successText:
        "Мы свяжемся с вами в ближайшее время. Менеджер уточнит все детали по пакету.",
      successButton: "Хорошо",
    },
  },

  // О нас
  about: {
    title: "Это страница о нас",
  },
};
